import { useEffect } from "react";
import type { GameState } from "../domain/types/index.js";
import { holdMsFor } from "../features/case/resolvePlayback.js";

export function useAutoAdvance(
  state: GameState,
  dispatch: (type: "ADVANCE_RESOLUTION") => void,
): void {
  const event =
    state.screen === "case.resolve" && state.overlay === "none"
      ? state.resolution?.events[state.resolution.index]
      : undefined;
  const holdMs = event ? holdMsFor(event) : null;
  const index = state.resolution?.index;

  useEffect(() => {
    if (holdMs == null) return;
    const id = window.setTimeout(() => dispatch("ADVANCE_RESOLUTION"), holdMs);
    return () => window.clearTimeout(id);
  }, [holdMs, index, state.screen, dispatch]);
}
